import { matchPath } from "react-router-dom";

/**
 * The pages reached from an emailed or shared link. Paths only, no page
 * imports, so the auth provider can ask about them without importing the app.
 */
export const ACCOUNT_PATHS = ['/invite/:token', '/forgot-password', '/reset-password/:token', '/verify-email/:token', '/book-demo', '/vcam/:code'] as const;

/**
 * "Book a demo" on its own, for a prospect's generated demo page
 * (<slug>.ardealy.link): its private-demo bar opens this page in a
 * transparent frame over the shop, so the request comes to us through the
 * same form as the signup's. See pages/common/book-demo.
 */
export const BOOK_DEMO_PATH = '/book-demo';

/** The page is drawn over someone else's: no background of its own, always light (see App). */
export const isBookDemoPage = (pathname: string) => pathname === BOOK_DEMO_PATH;

/**
 * The self-serve signup ("Start for free"), linked from the landing page. A
 * signed-out page like /login; a signed-in visitor is sent into the app.
 */
export const SIGNUP_PATH = '/start';

export const isAccountPath = (pathname: string) => ACCOUNT_PATHS.some((path) => matchPath(path, pathname));

/**
 * Where to go when the API ends this device's session. Usually the login
 * page, which says why. On an account page, stay: those work signed out, and
 * the reset that just ended the session wants to say "Password changed".
 */
export const afterSessionEnded = (pathname: string): 'stay' | 'login' => (isAccountPath(pathname) ? 'stay' : 'login');
